import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import {
  type DrawerFooterDataProps,
  drawerFooterDataSchema,
} from "./Drawer.schema";
import { DrawerFooter } from "./DrawerFooter";
import { DRAWER_FOOTER_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [DRAWER_FOOTER_TAG_NAME]: {
      props: DrawerFooterDataProps;
      handle: undefined;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-drawer-footer": HTMLElement;
  }
}

function RWCDrawerFooterComponent(): JSX.Element {
  return (
    <DrawerFooter>
      <slot />
    </DrawerFooter>
  );
}

componentManager.register(
  rwc(DRAWER_FOOTER_TAG_NAME, {
    component: RWCDrawerFooterComponent,
    dataSchema: drawerFooterDataSchema,
    usesSlots: true,
  }),
);
